import {
  Box,
  Button,
  FormControl,
  Grid,
  IconButton,
  InputAdornment,
  InputBase,
  MenuItem,
  Paper,
  styled,
  SvgIcon,
  Tab,
  Tabs,
  Tooltip,
  Typography
} from '@mui/material';
import { useEffect, useState } from 'react';
import CustomDataTable from '../../components/CustomDataTable';
import {
  colorPrimary,
  colorTextBlack,
  colorTextGrey
} from '../../config/theme';
import CustomTabLabel from '../../custom/CustomTabLabel';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  deleteContent,
  getContentList,
  publishContent,
  revertAllAddContentData,
  revertContentDetails,
  revertNewTagSection,
  revertPublishContent
} from '../../redux/reducers/contentSlice';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { createTitle, handleError } from '../../utils/utils';
import { setActiveModule } from '../../redux/reducers/layoutSlice';
import SnackBarBox from '../../components/SnackBarBox';
import _ from 'lodash';
import ConfirmBox from '../../components/ConfirmBox';
import ManageLearningPathsModal from './components/ManageLearningPathsModal';
import {
  formatContentTypeLabel,
  normalizeContentPublishStatus,
  resolveContentRowId
} from '../../utils/navigationMenu';
import {
  styledMenuItem,
  StyledSelect
} from '../productanalytics/UserAndRoleAnalytics';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { Calendar01Icon, FilterLinesIcon } from '../../utils/iconSvg';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

const Search = styled('div')(({ theme }) => ({
  position: 'relative',
  borderRadius: theme.shape.borderRadius,

  marginLeft: 0,
  marginRight: 10,
  width: '100%',
  [theme.breakpoints.up('sm')]: {
    marginLeft: theme.spacing(1),
    width: 'auto'
  }
}));

const SearchIconWrapper = styled('div')(({ theme }) => ({
  // padding: theme.spacing(0, 2),
  height: '100%',
  position: 'absolute',
  right: 6,
  pointerEvents: 'none',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center'
}));

let searchValue = '';
const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: 'inherit',
  width: '100%',
  '& .MuiInputBase-input': {
    padding: theme.spacing(1, 1, 1, 1.5),
    paddingRight: `calc(1em + ${theme.spacing(2)})`,
    transition: theme.transitions.create('width'),
    width: searchValue ? '25ch' : '0px',
    [theme.breakpoints.up('sm')]: {
      '&:focus': {
        width: searchValue ? '25ch' : '25ch',
        border: '1px solid #CBD2D9',
        borderRadius: '8px'
      }
    }
  }
}));

const ContentDashboard = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [initialValues, setInitalValues] = useState({
    tabValue: 0,
    page: 0,
    size: 10,
    searchFilter: ''
  });
  const [confirmation, setConfirmation] = useState(null);
  const [deleteContentId, setDeleteContentId] = useState(null);
  const [deleteContentData, setDeleteContentData] = useState(null);
  const [disabledButton, setDisabledButton] = useState(false);
  const [tempDateFilter, setTempDateFilter] = useState({
    dateType: null,
    startDate: null,
    endDate: null,
    sortBy: null
  });

  const [chart1Payload, setChart1Payload] = useState({
    dateType: 'all',
    startDate: null,
    endDate: null
  });

  const [open, setOpen] = useState(false);
  const [isManageLearningPathsOpen, setIsManageLearningPathsOpen] =
    useState(false);
  const [openCalenderModal, setOpenCalendarModal] = useState({
    startDate: false,
    endDate: false
  });
  const [sortByValue, setSortByValue] = useState(null);
  const [contentBy, setContentBy] = useState('');
  const [contentType, setContentType] = useState('');
  const [publishFeedback, setPublishFeedback] = useState(null);

  const {
    contentList,
    deleteContentResponse,
    isDeleteContentLoading,
    isDeleteContentSuccess
  } = useSelector(state => state.content);
  const { authData } = useSelector(state => state.auth);

  const {
    isPublishContentLoading,
    isPublishContentSuccess,
    isPublishContentFailed,
    publishContentResponse,
    publishContentErrorContainer
  } = useSelector(state => state.content);

  useEffect(() => {
    document.title = createTitle('Content Management');
    dispatch(setActiveModule('Content Management'));
    localStorage.removeItem('localContentId');
    dispatch(revertAllAddContentData());
    dispatch(revertPublishContent());
    return () => {
      dispatch(revertNewTagSection());
    };
  }, []);

  useEffect(() => {
    setDisabledButton(true);
    dispatch(
      getContentList({
        payload: {
          startDate: chart1Payload.startDate
            ? dayjs(chart1Payload.startDate).format('YYYY-MM-DD')
            : null,
          endDate: chart1Payload.endDate
            ? dayjs(chart1Payload.endDate).format('YYYY-MM-DD')
            : null,
          dateType: chart1Payload.dateType,
          sortBy: tempDateFilter.sortBy,
          paginationRequest: {
            type: 'all',
            page: initialValues.page,
            size: initialValues.size
          }
        },
        search: initialValues.searchFilter,
        contentType:
          initialValues.tabValue === 1
            ? ''
            : initialValues.tabValue === 2
              ? 'All'
              : initialValues.tabValue === 3
                ? 'Registered'
                : initialValues.tabValue === 4
                  ? 'PAF Only'
                  : '',
        status:
          initialValues.tabValue === 1
            ? 'Saved'
            : initialValues.tabValue === 2
              ? 'Publish'
              : initialValues.tabValue === 3
                ? 'Publish'
                : initialValues.tabValue === 4
                  ? 'Publish'
                  : ''
      })
    );
    setDisabledButton(false);
  }, [initialValues, chart1Payload, tempDateFilter]);

  useEffect(() => {
    if (!isPublishContentLoading && isPublishContentSuccess) {
      setInitalValues(prev => ({ ...prev, page: 0 }));
    }
  }, [isPublishContentLoading, isPublishContentSuccess]);

  useEffect(() => {
    if (!isDeleteContentLoading && isDeleteContentSuccess) {
      setInitalValues(prev => ({ ...prev, page: 0 }));
    }
  }, [isDeleteContentLoading, isDeleteContentSuccess]);

  useEffect(() => {
    if (!isPublishContentLoading && isPublishContentFailed) {
      setPublishFeedback({
        type: 'error',
        message:
          handleError(publishContentErrorContainer?.errorMessage) ||
          handleError(publishContentErrorContainer?.description) ||
          'Unable to update publish status. Please try again.'
      });
    }
  }, [
    isPublishContentLoading,
    isPublishContentFailed,
    publishContentErrorContainer
  ]);

  const handlePublishRow = (row, event) => {
    event.stopPropagation();

    const contentId = resolveContentRowId(row);
    const status = normalizeContentPublishStatus(row?.status);

    if (!contentId) {
      setPublishFeedback({
        type: 'error',
        message: 'Content ID is missing. Please save the content again.'
      });
      return;
    }

    dispatch(
      publishContent({
        payload: {
          contentId,
          loggedInUserName: authData?.userName,
          status,
          contentType: row?.contentType
        }
      })
    );
    setInitalValues(prev => ({ ...prev, page: 0 }));
  };

  const columns = [
    {
      uinqueKey: 'contentId',
      id: 'contentFileName',
      label: 'File Name',
      width: '220px',
      sortable: true
    },
    {
      id: 'uploadType',
      label: 'Upload Type'
    },
    {
      id: 'createdBy',
      label: 'Created By'
    },
    {
      id: 'createdDt',
      label: 'Creation Date',
      width: '150px',
      render: row => {
        return (
          <>
            <Typography fontSize={'14px'} fontWeight={'600'}>
              {row.createdDt
                ? moment(row.createdDt).format('DD/MM/YYYY')
                : 'NA'}
            </Typography>
          </>
        );
      }
    },
    {
      id: 'interactions',
      label: '# Interactions'
    },
    {
      id: 'contentType',
      label: 'Content Type',
      render: row => (
        <Typography fontSize={'14px'} fontWeight={'600'}>
          {formatContentTypeLabel(row?.contentType)}
        </Typography>
      )
    },
    {
      id: 'status',
      label: '',
      render: row => {
        const isSaved = normalizeContentPublishStatus(row?.status) === 'Saved';

        return (
          <Button
            variant={isSaved ? 'contained' : 'outlined'}
            disabled={disabledButton || isPublishContentLoading}
            onClick={e => handlePublishRow(row, e)}
            sx={{
              borderColor: colorPrimary,
              borderRadius: '6px',
              color: colorTextBlack,
              borderWidth: '2px',
              height: '26px',
              width: '86px',
              paddingX: '16px',
              paddingY: '6px',
              '&:hover': {
                borderColor: colorPrimary,
                // backgroundColor: 'transparent',
                borderRadius: '6px',
                borderWidth: '2px'
              }
            }}
          >
            {isSaved ? 'Publish' : 'Unpublish'}
          </Button>
        );
      }
    },
    {
      id: 'action',
      label: '',
      render: row => (
        <Tooltip title="Delete">
          <IconButton
            aria-label="delete"
            onClick={event => {
              event.stopPropagation();
              handleDeleteClick(row);
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M7.5 2.5H12.5M2.5 5H17.5M15.8333 5L15.2489 13.7661C15.1612 15.0813 15.1174 15.7389 14.8333 16.2375C14.5833 16.6765 14.206 17.0294 13.7514 17.2497C13.235 17.5 12.5759 17.5 11.2578 17.5H8.74221C7.42409 17.5 6.76503 17.5 6.24861 17.2497C5.79396 17.0294 5.41674 16.6765 5.16665 16.2375C4.88259 15.7389 4.83875 15.0813 4.75107 13.7661L4.16667 5M8.33333 8.75V12.9167M11.6667 8.75V12.9167"
                stroke="#1F2933"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </IconButton>
        </Tooltip>
      )
    }
  ];

  const handleDeleteClick = value => {
    setDeleteContentData(value?.uploadType);
    setConfirmation(true);
    setDeleteContentId(value?.contentId);
  };

  const deleteRowContent = () => {
    const payload = {
      contentId: deleteContentId,
      loggedInUserName: authData?.userName
    };
    dispatch(deleteContent({ payload }));
    setInitalValues({ ...initialValues, page: 0 });
    setDeleteContentId(null);
    setConfirmation(false);
  };

  const handleOnRowClick = row => {
    dispatch(revertContentDetails());
    if (row.uploadType === 'Flashcard') {
      return navigate(`/content-management/edit-flashcard`, {
        state: {
          encryptedContentId: row.encryptedContentId,
          contentId: row.contentId
        }
      });
    } else {
      return navigate(`/content-management/edit-content`, {
        state: {
          encryptedContentId: row.encryptedContentId,
          contentId: row.contentId
        }
      });
    }
  };

  const debouncedSearch = _.debounce(
    term => setInitalValues({ ...initialValues, searchFilter: term, page: 0 }),
    300
  );

  const handleSearch = e => {
    const term = e.target.value;
    // setSearch(term);
    if (term.length >= 3 || term.length === 0) {
      debouncedSearch(term);
    }
  };

  const handleOpenCalendar = type => {
    setOpenCalendarModal({ ...openCalenderModal, [type]: true });
  };

  const handleCloseCalendar = type => {
    setOpenCalendarModal({ ...openCalenderModal, [type]: false });
  };

  return (
    <>
      <Grid
        display={'flex'}
        justifyContent={'space-between'}
        alignItems={'center'}
      >
        <Typography fontSize={32} fontWeight="700" display={'flex'}>
          Content Dashboard
          <Typography
            ml={1}
            fontSize={20}
            fontWeight="700"
            alignSelf={'center'}
          >
            {/* ({usersData?.allCount}) */}
          </Typography>
        </Typography>

        <Grid display={'flex'} gap={2}>
          <Button
            sx={{
              width: '196px',
              height: '42px',
              boxShadow: 'none',
              fontWeight: 700,
              fontSize: '14px',
              color: colorTextBlack,
              border: `2px solid ${colorPrimary}`
            }}
            variant="outlined"
            onClick={() => setIsManageLearningPathsOpen(true)}
          >
            Learning paths
          </Button>
          <Button
            sx={{
              width: '196px',
              height: '42px',
              boxShadow: 'none',
              fontWeight: 700,
              fontSize: '14px',
              color: colorTextBlack,
              border: `2px solid ${colorPrimary}`
            }}
            variant="outlined"
            onClick={() => navigate('/content-management/add-new-flashcard')}
          >
            <SvgIcon
              fontSize="small"
              sx={{ marginRight: 0.6, height: '16px', width: '16px' }}
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                  stroke="#1F2933"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </SvgIcon>{' '}
            Add New Flashcard
          </Button>

          <Button
            sx={{
              width: '196px',
              height: '42px',
              boxShadow: 'none',
              fontWeight: '700',
              fontSize: '14px'
            }}
            // variant="outlined"
            variant="contained"
            onClick={() => navigate('/content-management/add-new-content')}
          >
            <SvgIcon
              fontSize="small"
              sx={{ marginRight: 0.6, height: '16px', width: '16px' }}
            >
              <svg
                width="17"
                height="16"
                viewBox="0 0 17 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M8.49996 2.66669V13.3334M3.16663 8.00002H13.8333"
                  stroke="#1F2933"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                />
              </svg>
            </SvgIcon>{' '}
            Add New Content
          </Button>
        </Grid>
      </Grid>

      <Grid
        container
        display={'flex'}
        flexDirection={'column'}
        elevation={0}
        // component={Paper}
        borderRadius={'8px'}
      >
        <Grid sx={{ padding: '18px 0px' }} width={'100%'}>
          <Grid
            display={'flex'}
            justifyContent={'space-between'}
            sx={{
              borderBottom: 1,
              borderColor: 'divider'
            }}
          >
            <Tabs
              value={initialValues.tabValue}
              onChange={(val, newValue) =>
                setInitalValues({
                  ...initialValues,
                  tabValue: newValue,
                  page: 0
                })
              }
              TabIndicatorProps={{
                sx: {
                  height: '4px'
                  // borderRadius: '4px'
                }
              }}
            >
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,

                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 0
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="16"
                      height="16"
                      viewBox="0 0 16 16"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M12.125 7.25H8.375M12.125 10.25H8.375M12.125 4.25H8.375M5.75 1.25L5.75 14.75M4.85 1.25H11.15C12.4101 1.25 13.0402 1.25 13.5215 1.49524C13.9448 1.71095 14.289 2.05516 14.5048 2.47852C14.75 2.95982 14.75 3.58988 14.75 4.85V11.15C14.75 12.4101 14.75 13.0402 14.5048 13.5215C14.289 13.9448 13.9448 14.289 13.5215 14.5048C13.0402 14.75 12.4101 14.75 11.15 14.75H4.85C3.58988 14.75 2.95982 14.75 2.47852 14.5048C2.05516 14.289 1.71095 13.9448 1.49524 13.5215C1.25 13.0402 1.25 12.4101 1.25 11.15V4.85C1.25 3.58988 1.25 2.95982 1.49524 2.47852C1.71095 2.05516 2.05516 1.71095 2.47852 1.49524C2.95982 1.25 3.58988 1.25 4.85 1.25Z"
                        stroke={
                          initialValues.tabValue === 0
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="All content"
                    count={
                      contentList?.allCount < 10
                        ? `0${contentList?.allCount}`
                        : contentList?.allCount
                    }
                    selected={initialValues.tabValue === 0}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 1
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="13.5"
                      height="13.5"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M4.25 1.25V3.8C4.25 4.22004 4.25 4.43006 4.33175 4.59049C4.40365 4.73161 4.51839 4.84635 4.65951 4.91825C4.81994 5 5.02996 5 5.45 5H10.55C10.97 5 11.1801 5 11.3405 4.91825C11.4816 4.84635 11.5964 4.73161 11.6683 4.59049C11.75 4.43006 11.75 4.22004 11.75 3.8V2M11.75 14.75V9.95C11.75 9.52996 11.75 9.31994 11.6683 9.15951C11.5964 9.01839 11.4816 8.90365 11.3405 8.83175C11.1801 8.75 10.97 8.75 10.55 8.75H5.45C5.02996 8.75 4.81994 8.75 4.65951 8.83175C4.51839 8.90365 4.40365 9.01839 4.33175 9.15951C4.25 9.31994 4.25 9.52996 4.25 9.95V14.75M14.75 5.99411V11.15C14.75 12.4101 14.75 13.0402 14.5048 13.5215C14.289 13.9448 13.9448 14.289 13.5215 14.5048C13.0402 14.75 12.4101 14.75 11.15 14.75H4.85C3.58988 14.75 2.95982 14.75 2.47852 14.5048C2.05516 14.289 1.71095 13.9448 1.49524 13.5215C1.25 13.0402 1.25 12.4101 1.25 11.15V4.85C1.25 3.58988 1.25 2.95982 1.49524 2.47852C1.71095 2.05516 2.05516 1.71095 2.47852 1.49524C2.95982 1.25 3.58988 1.25 4.85 1.25H10.0059C10.3728 1.25 10.5562 1.25 10.7288 1.29145C10.8819 1.32819 11.0282 1.3888 11.1624 1.47104C11.3138 1.5638 11.4435 1.69352 11.7029 1.95294L14.0471 4.29706C14.3065 4.55648 14.4362 4.6862 14.529 4.83757C14.6112 4.97178 14.6718 5.1181 14.7086 5.27115C14.75 5.44378 14.75 5.62723 14.75 5.99411Z"
                        stroke={
                          initialValues.tabValue === 1
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Saved only"
                    count={
                      contentList?.savedCount < 10
                        ? `0${contentList?.savedCount}`
                        : contentList?.savedCount
                    }
                    selected={initialValues.tabValue === 1}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 2
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="12"
                      height="13.5"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.25 7.25V5C3.25 2.92893 4.92893 1.25 7 1.25C8.81422 1.25 10.3275 2.53832 10.675 4.25M4.6 14.75H9.4C10.6601 14.75 11.2902 14.75 11.7715 14.5048C12.1948 14.289 12.539 13.9448 12.7548 13.5215C13 13.0402 13 12.4101 13 11.15V10.85C13 9.58988 13 8.95982 12.7548 8.47852C12.539 8.05516 12.1948 7.71095 11.7715 7.49524C11.2902 7.25 10.6601 7.25 9.4 7.25H4.6C3.33988 7.25 2.70982 7.25 2.22852 7.49524C1.80516 7.71095 1.46095 8.05516 1.24524 8.47852C1 8.95982 1 9.58988 1 10.85V11.15C1 12.4101 1 13.0402 1.24524 13.5215C1.46095 13.9448 1.80516 14.289 2.22852 14.5048C2.70982 14.75 3.33988 14.75 4.6 14.75Z"
                        stroke={
                          initialValues.tabValue === 2
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>

                    {/* <UserGroupRemoveIcon
                    color={
                      initialValues.tabValue === 2
                        ? colorTextBlack
                        : colorTextGrey
                    }
                  /> */}
                  </SvgIcon>
                }
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Free content"
                    count={
                      contentList?.freeCount < 10
                        ? `0${contentList?.freeCount}`
                        : contentList?.freeCount
                    }
                    selected={initialValues.tabValue === 2}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 3
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M3.00002 16.3631C3.45195 16.5 4.06237 16.5 5.1 16.5H12.9C13.9376 16.5 14.548 16.5 15 16.3631M3.00002 16.3631C2.90312 16.3337 2.8135 16.2981 2.72852 16.2548C2.30516 16.039 1.96095 15.6948 1.74524 15.2715C1.5 14.7902 1.5 14.1601 1.5 12.9V5.1C1.5 3.83988 1.5 3.20982 1.74524 2.72852C1.96095 2.30516 2.30516 1.96095 2.72852 1.74524C3.20982 1.5 3.83988 1.5 5.1 1.5H12.9C14.1601 1.5 14.7902 1.5 15.2715 1.74524C15.6948 1.96095 16.039 2.30516 16.2548 2.72852C16.5 3.20982 16.5 3.83988 16.5 5.1V12.9C16.5 14.1601 16.5 14.7902 16.2548 15.2715C16.039 15.6948 15.6948 16.039 15.2715 16.2548C15.1865 16.2981 15.0969 16.3337 15 16.3631M3.00002 16.3631C3.00026 15.7561 3.0039 15.4349 3.05764 15.1647C3.29436 13.9747 4.22466 13.0444 5.41473 12.8076C5.70453 12.75 6.05302 12.75 6.75 12.75H11.25C11.947 12.75 12.2955 12.75 12.5853 12.8076C13.7753 13.0444 14.7056 13.9747 14.9424 15.1647C14.9961 15.4349 14.9997 15.7561 15 16.3631M12 7.125C12 8.78185 10.6569 10.125 9 10.125C7.34315 10.125 6 8.78185 6 7.125C6 5.46815 7.34315 4.125 9 4.125C10.6569 4.125 12 5.46815 12 7.125Z"
                        stroke={
                          initialValues.tabValue === 3
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Registered content"
                    count={
                      contentList?.registeredCount < 10
                        ? `0${contentList?.registeredCount}`
                        : contentList?.registeredCount
                    }
                    selected={initialValues.tabValue === 3}
                  />
                }
              />
              <Tab
                sx={{
                  fontSize: '16px',
                  minHeight: 44,
                  height: 44,
                  color: colorTextGrey,
                  '&.Mui-selected': {
                    color:
                      initialValues.tabValue === 4
                        ? colorTextBlack
                        : colorTextGrey
                  }
                }}
                icon={
                  <SvgIcon sx={{ height: '18px', width: '18px' }}>
                    <svg
                      width="15"
                      height="15"
                      viewBox="0 0 18 18"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M6.75 12.75L3 16.5M11.25 12.75L15 16.5M9 1.5V3M9 16.5V12.75M3.9 12.75H14.1C14.9401 12.75 15.3601 12.75 15.681 12.5865C15.9632 12.4427 16.1927 12.2132 16.3365 11.931C16.5 11.6101 16.5 11.1901 16.5 10.35V5.4C16.5 4.55992 16.5 4.13988 16.3365 3.81901C16.1927 3.53677 15.9632 3.3073 15.681 3.16349C15.3601 3 14.9401 3 14.1 3H3.9C3.05992 3 2.63988 3 2.31901 3.16349C2.03677 3.3073 1.8073 3.53677 1.66349 3.81901C1.5 4.13988 1.5 4.55992 1.5 5.4V10.35C1.5 11.1901 1.5 11.6101 1.66349 11.931C1.8073 12.2132 2.03677 12.4427 2.31901 12.5865C2.63988 12.75 3.05992 12.75 3.9 12.75Z"
                        stroke={
                          initialValues.tabValue === 4
                            ? colorTextBlack
                            : colorTextGrey
                        }
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </SvgIcon>
                }
                iconPosition="start"
                label={
                  <CustomTabLabel
                    title="Pehla Akshar Foundation content"
                    count={
                      contentList?.pafCount < 10
                        ? `0${contentList?.pafCount}`
                        : contentList?.pafCount
                    }
                    selected={initialValues.tabValue === 4}
                  />
                }
              />
            </Tabs>
          </Grid>
        </Grid>
        <Grid
          container
          display={'flex'}
          flexDirection={'column'}
          elevation={0}
          component={Paper}
          borderRadius={'8px'}
          sx={{ paddingX: '14px' }}
        >
          <Box width={'100%'} marginBottom={'15px'}>
            <Box
              display={'flex'}
              justifyContent={'flex-end'}
              // flexDirection={'row-reverse'}
              alignItems={'center'}
              margin="auto 10px"
            >
              <Search>
                <SearchIconWrapper>
                  <svg
                    width="21"
                    height="20"
                    viewBox="0 0 21 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 17.5L14.375 13.875M16.3333 9.16667C16.3333 12.8486 13.3486 15.8333 9.66667 15.8333C5.98477 15.8333 3 12.8486 3 9.16667C3 5.48477 5.98477 2.5 9.66667 2.5C13.3486 2.5 16.3333 5.48477 16.3333 9.16667Z"
                      stroke="#ABB4BD"
                      strokeWidth="1.5"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </SearchIconWrapper>
                <StyledInputBase
                  onChange={e => {
                    // searchValue = e.target.value;
                    handleSearch(e);
                  }}
                  placeholder="Search here…"
                />
              </Search>
              {/* <Box sx={{ width: '224px' }} marginY={1.5} marginRight={'8px'}>
                <FormControl fullWidth sx={{ marginRight: 1 }}>
                  <Autocomplete
                    size="small"
                    value={contentBy}
                    onChange={(event, newValue) => {
                      setContentBy(newValue);
                    }}
                    getOptionLabel={getOptionLabel}
                    disableClearable
                    isOptionEqualToValue={(option, value) => option === value}
                    options={[
                      { label: 'All', id: 'All' },
                      { label: 'Registered', id: 'Registered' },
                      { label: 'PAF only', id: 'PAF only' }
                      // { label: 'Free', id: 'Free' }
                    ]}
                    renderInput={params => (
                      <TextField
                        // name="contentType"
                        {...params}
                        placeholder="Select content type"
                      />
                    )}
                    ListboxProps={{
                      sx: {
                        '& .MuiAutocomplete-option:hover': {
                          backgroundColor: colorSecondary
                        }
                      }
                    }}
                  />
                </FormControl>
              </Box>
              <Box sx={{ width: '224px' }} marginY={1.5} marginRight={'8px'}>
                <FormControl fullWidth sx={{ marginRight: 1 }}>
                  <Autocomplete
                    size="small"
                    value={contentType}
                    onChange={(event, newValue) => {
                      setContentType(newValue);
                    }}
                    getOptionLabel={getOptionLabel}
                    disableClearable
                    isOptionEqualToValue={(option, value) => option === value}
                    options={[
                      { label: 'All', id: 'All' },
                      { label: 'Registered', id: 'Registered' },
                      { label: 'PAF only', id: 'PAF only' }
                      // { label: 'Free', id: 'Free' }
                    ]}
                    renderInput={params => (
                      <TextField
                        // name="contentType"
                        {...params}
                        placeholder="Select content type"
                      />
                    )}
                    ListboxProps={{
                      sx: {
                        '& .MuiAutocomplete-option:hover': {
                          backgroundColor: colorSecondary
                        }
                      }
                    }}
                  />
                </FormControl>
              </Box> */}
              <Box display={'flex'} justifyContent={'space-between'}>
                <Box sx={{ width: '255px' }} marginY={1.5}>
                  <FormControl variant="outlined" fullWidth size="small">
                    <StyledSelect
                      IconComponent={Calendar01Icon}
                      size="small"
                      open={open}
                      value={
                        open ? tempDateFilter.dateType : chart1Payload.dateType
                      }
                      onOpen={(e, va) => {
                        setOpen(true);
                        setTempDateFilter({
                          ...tempDateFilter,
                          dateType: chart1Payload.dateType,
                          startDate: chart1Payload.startDate,
                          endDate: chart1Payload.endDate
                        });
                      }}
                      onChange={e => {
                        setTempDateFilter({
                          ...tempDateFilter,
                          dateType: e.target.value,
                          startDate: null,
                          endDate: null
                        });
                      }}
                      renderValue={value => {
                        let data = open ? tempDateFilter : chart1Payload;
                        if (data.dateType == 'all') {
                          return (
                            <Typography
                              sx={{
                                display: 'flex',
                                alignItems: 'center',
                                color: '#ABB4BD'
                              }}
                            >
                              <SvgIcon fontSize="small" sx={{ marginRight: 1 }}>
                                <FilterLinesIcon color="#ABB4BD" />
                              </SvgIcon>
                              Select date
                            </Typography>
                          );
                        }
                        switch (data.dateType) {
                          case 'selected_date':
                            return `${data.startDate ? dayjs(data.startDate).format('DD/MM/YY') : ''} - ${data.endDate ? dayjs(data.endDate).format('DD/MM/YY') : ''}`;
                          case 'Week':
                            return 'Last Week';
                          case 'Month':
                            return 'This Month';
                          case 'past_3_months':
                            return 'Past 3 months';
                          case 'Past_1_Year':
                            return 'Past 1 year';
                          default:
                            return;
                        }
                      }}
                      sx={{
                        '& .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '&:hover  .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '&.Mui-focused  .MuiOutlinedInput-notchedOutline': {
                          borderColor: '#CBD2D9'
                        },
                        '& .MuiOutlinedInput-root': {
                          borderRadius: 8
                        }
                      }}
                    >
                      <MenuItem
                        sx={{ ...styledMenuItem, paddingX: 0, border: 'none' }}
                        value="selected_date"
                        disableRipple
                      >
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Box display={'flex'} gap={1}>
                            <FormControl
                              variant="outlined"
                              size="small"
                              sx={{ width: '175px' }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  mb: 0.5
                                }}
                              >
                                Start Date
                              </Typography>
                              <DatePicker
                                maxDate={dayjs()}
                                value={dayjs(tempDateFilter.startDate)}
                                onOpen={() => handleOpenCalendar('startDate')}
                                onClose={() => handleCloseCalendar('startDate')}
                                open={openCalenderModal.startDate}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    placeholder: 'Start Date',
                                    error: false,
                                    InputProps: {
                                      sx: { color: colorTextBlack },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleOpenCalendar('startDate')
                                            }
                                          >
                                            <SvgIcon
                                              sx={{
                                                width: '16px',
                                                height: '16px',
                                                ml: 1
                                              }}
                                            >
                                              <Calendar01Icon />
                                            </SvgIcon>
                                          </IconButton>
                                        </InputAdornment>
                                      )
                                    },
                                    sx: {
                                      paddingRight: 0 // Remove extra padding from the hidden icon
                                    }
                                  }
                                }}
                                onChange={date =>
                                  setTempDateFilter({
                                    ...tempDateFilter,
                                    dateType: 'selected_date',
                                    startDate: date,
                                    endDate: date
                                  })
                                }
                                components={{ OpenPickerIcon: () => null }}
                              />
                            </FormControl>
                            <FormControl
                              variant="outlined"
                              size="small"
                              sx={{ width: '175px' }}
                            >
                              <Typography
                                sx={{
                                  fontSize: '14px',
                                  fontWeight: 600,
                                  mb: 0.5
                                }}
                              >
                                End Date
                              </Typography>
                              <DatePicker
                                maxDate={dayjs()}
                                minDate={dayjs(tempDateFilter.startDate)}
                                // label="End Date"
                                value={dayjs(tempDateFilter.endDate)}
                                open={openCalenderModal.endDate}
                                onOpen={() => handleOpenCalendar('endDate')}
                                onClose={() => handleCloseCalendar('endDate')}
                                format="DD/MM/YYYY"
                                slotProps={{
                                  textField: {
                                    size: 'small',
                                    error: false,
                                    InputProps: {
                                      sx: { color: colorTextBlack },
                                      startAdornment: (
                                        <InputAdornment position="start">
                                          <IconButton
                                            size="small"
                                            onClick={() =>
                                              handleOpenCalendar('endDate')
                                            }
                                          >
                                            <SvgIcon
                                              sx={{
                                                width: '16px',
                                                height: '16px',
                                                ml: 1
                                              }}
                                            >
                                              <Calendar01Icon />
                                            </SvgIcon>
                                          </IconButton>
                                        </InputAdornment>
                                      )
                                    },
                                    sx: {
                                      paddingRight: 0 // Remove extra padding from the hidden icon
                                    }
                                  }
                                }}
                                onChange={date => {
                                  setTempDateFilter({
                                    ...tempDateFilter,
                                    dateType: 'selected_date',
                                    endDate: date
                                  });
                                }}
                                components={{ OpenPickerIcon: () => null }}
                                // components={{
                                //   OpenPickerIcon: props => (
                                //     <IconButton size="small" {...props}>
                                //       <Calendar01Icon />
                                //     </IconButton>
                                //   )
                                // }}
                              />
                            </FormControl>
                          </Box>
                        </LocalizationProvider>
                      </MenuItem>

                      <MenuItem sx={styledMenuItem} value="Week" disableRipple>
                        Last Week
                      </MenuItem>
                      <MenuItem sx={styledMenuItem} value="Month" disableRipple>
                        This Month
                      </MenuItem>
                      <MenuItem
                        sx={styledMenuItem}
                        value="past_3_months"
                        disableRipple
                      >
                        Past 3 month
                      </MenuItem>
                      <MenuItem
                        sx={styledMenuItem}
                        value="Past_1_Year"
                        disableRipple
                      >
                        Past 1 year
                      </MenuItem>
                      <MenuItem
                        // disabled={
                        //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                        // }
                        sx={{
                          border: '1px solid #E4E7EB',
                          backgroundColor: colorPrimary,
                          marginX: 1,
                          borderRadius: 3,
                          fontWeight: 700,
                          fontSize: '14px',
                          justifyContent: 'center',
                          marginY: 1,
                          '&:hover': {
                            background: colorPrimary
                          }
                        }}
                        onClick={() => {
                          if (tempDateFilter.dateType) {
                            setChart1Payload({
                              ...chart1Payload,
                              dateType: tempDateFilter.dateType,
                              startDate: tempDateFilter.startDate,
                              endDate: tempDateFilter.endDate
                            });
                          }
                          setTempDateFilter({
                            dateType: null,
                            endDate: null,
                            startDate: null
                          });
                          setOpen(false);
                        }}
                      >
                        Apply
                      </MenuItem>
                      <MenuItem
                        // disabled={
                        //   !(tempDateFilter.dateType || chart1Payload.dateFilter)
                        // }
                        sx={{
                          border: '1px solid #E4E7EB',
                          backgroundColor: colorPrimary,
                          marginX: 1,
                          borderRadius: 3,
                          fontWeight: 700,
                          fontSize: '14px',
                          justifyContent: 'center',
                          marginY: 1,
                          '&:hover': {
                            background: colorPrimary
                          }
                        }}
                        onClick={() => {
                          setChart1Payload({
                            ...chart1Payload,
                            dateType: 'all',
                            startDate: null,
                            endDate: null
                          });
                          setTempDateFilter({
                            startDate: null,
                            dateType: null,
                            endDate: null
                          });
                          setOpen(false);
                        }}
                      >
                        Close
                      </MenuItem>
                    </StyledSelect>
                  </FormControl>
                </Box>

                {/* <Box marginY={1.5}>
                  <FormControl
                    variant="outlined"
                    size="small"
                    // sx={{ marginRight: 2 }}
                  >
                    <StyledSelect
                      size="small"
                      // sx={{ minWidth: '179px', height: '40px' }}
                      sx={{ minWidth: '179px' }}
                      placeholder="Sort by"
                      value={tempDateFilter?.sortBy}
                      onChange={e => {
                        // setSortByValue(e.target.value);
                        setTempDateFilter(prev => ({
                          ...prev,
                          sortBy: e.target.value
                        }));
                      }}
                      displayEmpty
                      renderValue={selected => {
                        if (!selected) {
                          return (
                            <div
                              style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                width: '100%'
                              }}
                            >
                              <Typography
                                sx={{
                                  display: 'flex',
                                  alignItems: 'center',
                                  color: '#ABB4BD'
                                }}
                              >
                                <SvgIcon
                                  fontSize="small"
                                  sx={{ marginRight: 1 }}
                                >
                                  <svg
                                    width="16"
                                    height="16"
                                    viewBox="0 0 16 16"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <path
                                      d="M11.3333 2.66675V13.3334M11.3333 13.3334L8.66667 10.6667M11.3333 13.3334L14 10.6667M4.66667 13.3334V2.66675M4.66667 2.66675L2 5.33341M4.66667 2.66675L7.33333 5.33341"
                                      stroke="#ABB4BD"
                                      strokeWidth="1.5"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                    />
                                  </svg>
                                </SvgIcon>
                                Sort by
                              </Typography>
                              <SvgIcon fontSize="small">
                                <svg
                                  width="16"
                                  height="16"
                                  viewBox="0 0 16 16"
                                  fill="none"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    d="M4 6L8 10L12 6"
                                    stroke="#1F2933"
                                    strokeWidth="1.5"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                  />
                                </svg>
                              </SvgIcon>
                            </div>
                          );
                        }
                        return (
                          <Typography
                            sx={{
                              color: colorTextBlack,
                              fontWeight: '500',
                              fontSize: '14px'
                            }}
                          >
                            {
                              SORTING_DATA.find(cc => cc.value === selected)
                                .label
                            }
                          </Typography>
                        );
                      }}
                      IconComponent={() => null}
                    >
                      {SORTING_DATA.map((cc, key) => (
                        <MenuItem
                          sx={styledMenuItem}
                          key={key}
                          value={cc.value}
                          disableRipple
                        >
                          {cc.label}
                        </MenuItem>
                      ))}
                    </StyledSelect>
                  </FormControl>
                </Box> */}
              </Box>
            </Box>

            <CustomDataTable
              // allowSelection={true}
              columns={columns}
              defaultOrderBy={'createdDate'}
              data={
                contentList?.contentList.length > 0
                  ? contentList?.contentList
                  : []
              }
              onPageChange={val => {
                setInitalValues({ ...initialValues, page: val });
              }}
              onRowsPerPageChange={val => {
                setInitalValues({ ...initialValues, size: val });
              }}
              defaultPage={initialValues.page}
              // selectedRows={[...selectedUser]}
              // onSelectionChange={val => {
              //   setSelectedUsers(val);
              // }}
              defaultRowsPerPage={initialValues.size}
              totalCount={
                initialValues.tabValue === 0
                  ? contentList?.allCount
                  : initialValues.tabValue === 1
                    ? contentList?.savedCount
                    : initialValues.tabValue === 2
                      ? contentList?.freeCount
                      : initialValues.tabValue === 3
                        ? contentList?.registeredCount
                        : initialValues.tabValue === 4
                          ? contentList?.pafCount
                          : 0
              }
              onRowClick={row => handleOnRowClick(row)}
            />
          </Box>
        </Grid>
      </Grid>
      <ConfirmBox
        isOpen={confirmation}
        title={`Delete ${deleteContentData === 'Flashcard' ? 'Flashcard' : 'content'}!`}
        subtitle={`Are you sure you want to delete this ${deleteContentData === 'Flashcard' ? 'flashcard' : 'content'}?`}
        handleClose={() => setConfirmation(null)}
        handleSubmit={deleteRowContent}
      />

      {!isDeleteContentLoading && isDeleteContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(deleteContentResponse?.message)}
        />
      )}

      {!isPublishContentLoading && isPublishContentSuccess && (
        <SnackBarBox
          type="success"
          message={handleError(publishContentResponse?.message)}
        />
      )}

      {publishFeedback && (
        <SnackBarBox
          type={publishFeedback.type}
          message={publishFeedback.message}
        />
      )}

      <ManageLearningPathsModal
        open={isManageLearningPathsOpen}
        handleClose={() => setIsManageLearningPathsOpen(false)}
      />
    </>
  );
};

export default ContentDashboard;
